/**
 * CargoPortsManager — the Cargo (solids) curated port list.
 *
 * Parity surface for the Bunker Ports tab: same panel, same contract, bound to
 * the cargo module. See PortsManager.js for the behaviour.
 */

import React from 'react';
import PortsManager from './PortsManager';

const CargoPortsManager = () => <PortsManager module="cargo" />;

export default CargoPortsManager;
